import { render, staticRenderFns } from "./top-brand-data.vue?vue&type=template&id=ac837040&scoped=true"
import script from "./top-brand-data.vue?vue&type=script&lang=js"
export * from "./top-brand-data.vue?vue&type=script&lang=js"
import style0 from "./top-brand-data.vue?vue&type=style&index=0&id=ac837040&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac837040",
  null
  
)

export default component.exports